import actionTypes from './actionTypes'

const processingActions = {
	processingInitializeSuccess(icons) {
		return {
			type: actionTypes.PROCESSING_INITIALIZE_SUCCESS,
			icons,
		}
	},
	processingInitializeError() {
		return {
			type: actionTypes.PROCESSING_INITIALIZE_ERROR,
		}
	},
	processingIconSuccess(icon) {
		return {
			type: actionTypes.PROCESSING_ICON_SUCCESS,
			icon,
		}
	},
	processingIconError(icon) {
		return {
			type: actionTypes.PROCESSING_ICON_ERROR,
			icon,
		}
	},
}

export default processingActions
